function getCookie(cname) {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(window.document.cookie)
  const ca = decodedCookie.split(';')
  //eslint-disable-next-line
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    //eslint-disable-next-line
    while (c.charAt(0) === ' ') {
      //eslint-disable-next-line
      c = c.substring(1)
    }
    //eslint-disable-next-line
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export default getCookie
